// extracted by mini-css-extract-plugin
export default {"home":"Vb7+g"};